import './i18n'
import './styles/_index.scss'

export { default as routes } from './ui/routes'
export { default as reducers } from './redux/reducers'
